module.exports = __webpack_public_path__ + "static/media/Email2.afd52cba.svg";